import { render } from "./App.vue?vue&type=template&id=fc8454fa&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fc8454fa&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=fc8454fa&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Downloads\\Kad Adeeb\\adeebxhanna\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8454fa"]])

export default __exports__